import { useFormik, FormikValues } from "formik";
import type { SaferFormikType } from "./SaferFormikType";

export const useSaferFormik = <FormValues>(
  ...args: Parameters<typeof useFormik<FormValues & FormikValues>>
): SaferFormikType<FormValues> => {
  return useFormik<FormValues & FormikValues>(...args);
};
